export const ColorPluginID = 'color';
export const colorPlugin = {
    id: ColorPluginID,
};
